import React from 'react';

export const FieldGroupContext = React.createContext();